
import React, { useMemo } from 'react';
import { Page, PickerHOC, TargetsWrapper, UserWrapper } from '@coinscrap/webapp-core';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';

import { ClientDataBase } from './ClientDataBase';

export const ClientData = PickerHOC(
	{
		target: {
			sourceWrapper: TargetsWrapper,
			sourcePath: 'targets',
			arrayItemMatcher: {
				type: 'param',
				paramName: 'targetId',
				itemPropertyPath: 'id',
			},
		},
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
	},
	LoadingScreen,
)(() => {
	let { query } = Page.use();

	const internalStep = useMemo(() => query?.internalStep && parseInt(query?.internalStep), [
		query,
	]);
	const editMode = useMemo(() => query?.editMode && query?.editMode, [query]);

	const { target, user } = PickerHOC.use();

	if (internalStep || editMode) {
		console.log('💢 query, internalStep, editMode', query, internalStep, editMode);
	}

	return (
		<ClientDataBase
			internalStep={internalStep}
			target={target}
			user={user}
			isB2B={false}
			editMode={editMode}
		/>
	);
});
